import { useDataChange } from 'Simple/Data.js'

import { PAYOR_FILTERS } from './constants.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
  })

  return async function onChange(value) {
    if (!value) return

    change(next => {
      next.filter = value.some(item => item.data.is_new === false)
        ? PAYOR_FILTERS.EXISTING
        : PAYOR_FILTERS.NEW
    })
  }
}
